// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65030":"e090eadc","73516":"f8ca3919","73586":"c3fedcef","77815":"f8ca3919","93477":"df1940e8"}[chunkId] + ".chunk.css";
};